import { getNestedPropertyOrDefault } from 'style-utils/core/createExtractCssFromProps/utils/getNestedPropertyOrDefault';
import { responsive } from './utils/responsive';
import { CSSObject } from 'styled-components';
import { scales, transforms } from './utils/configs';

export const css =
  (args: CSSObject | ((...args: any[]) => any)) =>
  (props: Record<string, unknown> = {}) => {
    const theme = { ...(props.theme || props) };
    let result: CSSObject = {};
    const obj = typeof args === 'function' ? args(theme) : args;
    const styles = responsive(obj)(theme);

    for (const key in styles) {
      const x = styles[key];
      const val = typeof x === 'function' ? x(theme) : x;

      if (key === 'variant') {
        const variant = css(getNestedPropertyOrDefault(theme, val))(theme);
        result = { ...result, ...variant };
        continue;
      }

      if (val && typeof val === 'object') {
        result[key] = css(val)(theme);
        continue;
      }

      const prop = key;
      const scaleName = getNestedPropertyOrDefault(scales, prop);
      const scale = getNestedPropertyOrDefault(
        theme,
        scaleName,
        getNestedPropertyOrDefault(theme, prop, {}),
      );
      const transform = getNestedPropertyOrDefault(
        transforms,
        prop,
        getNestedPropertyOrDefault,
      );
      const value = transform(scale, val, val);

      result[prop] = value;
    }

    return result;
  };

export default css;
